import { Injectable } from "@angular/core";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { UserPreference } from "../../models/UserPreference";
import {  errorMessages } from "../../settings";
import { BaseService } from "./base.service";

@Injectable()
export class HospitalsummaryService extends BaseService {

  constructor(
    private _analyticsService: AnalyticsService,
    private _commonService: CommonService,
  ) {
    super();
   }

  init(widget: any) {
    console.log('HospitalsummaryService')
    widget.dataLoaded = false;
    widget.Title = 'Hospital Orders Summary';
    let userPref: UserPreference = this._commonService.getUserPreference();
    console.time('gethospitalordersummary');
    this._analyticsService.gethospitalordersummary(userPref.FacilityId, userPref.CustomerId)
      .subscribe((result: any) => {
        console.timeEnd('gethospitalordersummary');
        console.log('gethospitalordersummary', result);
        widget.chartOptions = this.chartOptions();
        widget.errorMessage = null;
        if (result && result.length > 0) {
          widget.dataLoaded = false;
          let hosSummary:any = result[0];
          widget.chartOptions.xAxis.data = ['Below 1 Hr', '1-3 Hrs', '3-5 Hrs', '5-7 Hrs', '7-24 Hrs', 'Above 24 hrs'];

          this.addDataSeries(widget.chartOptions, [hosSummary.BELOW_1_HOUR_ORDER_COUNT,
            hosSummary.BTW_1_AND_3_HOURS_ORDER_COUNT,
            hosSummary.BTW_3_AND_5_HOURS_ORDER_COUNT,
            hosSummary.BTW_5_AND_7_HOURS_ORDER_COUNT,
            hosSummary.BTW_7_AND_24_HOURS_ORDER_COUNT,
            hosSummary.ABOVE_24_HOURS_ORDER_COUNT
          ], 'Hospital Orders','bar')
          
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;
      }
        , err => {
          console.timeEnd('gethospitalordersummary');
          console.log('gethospitalordersummary', err);
          widget.dataLoaded = true;
        }
      );
  }

  reload(widget: any) { }

  remove(widget: any) { }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/hospitalsummary.service.ts